import React, { useState } from "react";
import topLogo from "../assets/images/mozzlelogo.png"
import Logo from "../assets/images/banner-img.png";
import flag from "../assets/images/flag.png";
import SignIcon from "../assets/images/symbole.png";
import { HiOutlineMenuAlt3 } from "react-icons/hi";
import { useWeb3React } from "@web3-react/core";
const Header = ({ connect }) => {
  const { account } = useWeb3React();
  const [show, setShow] = useState(false);
  return (
    <div>
      <div className="container relative">
        <div className="flex items-center justify-center py-6">
          <div>
            <img src={topLogo} alt="" className="w-28" />
          </div>
          {/* <div> */}
            {/* <div className="hidden md:flex items-center ">
              {account ? (
                <>
                  <button>
                    <img src={flag} alt="" className="p-2" />
                  </button>
                  <button className="bg-primary py-2 px-4 rounded-full text-primary-text font-medium mx-2">
                    PLAY MOZZLE
                  </button>
                  <button className="bg-transparent text-secondary border border-secondary py-2 px-6 rounded-full font-medium ml-2 flex items-center">
                    <img src={SignIcon} alt="" className="mr-2 w-8" />
                    <span>Get MOZZLE Now</span>
                  </button>
                  <button
                    onClick={connect}
                    className="bg-primary py-2 px-4 rounded-full text-primary-text font-medium mx-2"
                  >
                    Dissconnect
                  </button>
                </>
              ) : (
                <button
                  className="bg-primary py-2 px-4 rounded-full text-primary-text font-medium mx-2"
                  // onClick={connect}
                >
                  Buy Now
                </button>
              )}
            </div> */}

            {/* <button
              className="text-3xl md:hidden"
              onClick={() => setShow((prev) => !prev)}
            >
              <HiOutlineMenuAlt3 />
            </button>
            <div
              className={`fixed left-[2%] md:hidden w-[96%]  top-[120px] transition-height duration-300 bg-[#162400] rounded-2xl z-10 ${
                show ? " max-h-max" : "max-h-0"
              } overflow-hidden`}
            >
              <div className=" grid gap-6 items-center justify-center py-10">
                {account ? (
                  <>
                    <button className="flex justify-center">
                      <img src={flag} alt="" className="p-2" />
                    </button>
                    <button className="bg-primary py-2 px-4 rounded-full text-primary-text font-medium mx-2">
                      PLAY MOZZLE
                    </button>
                    <button className="bg-transparent text-secondary border border-secondary py-2 px-6 rounded-full font-medium  flex items-center">
                      <img src={SignIcon} alt="" className="mr-2 w-8" />
                      <span>Get MOZZLE Now</span>
                    </button>
                    <button
                      onClick={connect}
                      className="bg-primary py-2 px-4 rounded-full text-primary-text font-medium mx-2"
                    >
                      Dissconnect
                    </button>
                  </>
                ) : (
                  <button
                    className="bg-primary py-2 px-4 rounded-full text-primary-text font-medium mx-2"
                    onClick={connect}
                  >
                    Connect Wallet
                  </button>
                )}
              </div>
            </div> */}
          {/* </div> */}
        </div>
      </div>
    </div>
  );
};

export default Header;
